import { render } from "./sidebnr.vue?vue&type=template&id=2c67bd73&scoped=true"
import script from "./sidebnr.vue?vue&type=script&lang=js"
export * from "./sidebnr.vue?vue&type=script&lang=js"

import "./sidebnr.vue?vue&type=style&index=0&id=2c67bd73&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c67bd73"],['__file',"src/js/components/sidebnr.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2c67bd73"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2c67bd73', __exports__)) {
    api.reload('2c67bd73', __exports__)
  }
  
  module.hot.accept("./sidebnr.vue?vue&type=template&id=2c67bd73&scoped=true", () => {
    api.rerender('2c67bd73', render)
  })

}


export default __exports__